import { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate, useLocation } from "react-router-dom";
import moment from "moment";

import TaskProvider, { useTask } from "context/client/task";

import DashboardContentLayout from "components/layouts/DashboardContentLayout";
import PlaceholderPage from "components/PlaceholderPage";
import TaskView from "page_components/shared/tasks/TaskView";
import {
  AcceptTaskModal,
  CancelTaskModal,
  ClientCommentsModal,
} from "page_components/shared/tasks/modals";

import useResponsive from "libs/helpers/useResponsive";

import { ReactComponent as TrashIcon } from "assets/icons/new/trash.svg";
import { ReactComponent as PencilIcon } from "assets/icons/new/pencil.svg";
import { ReactComponent as CheckIcon } from "assets/icons/new/check.svg";

const TaskSingle = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();
  const { max } = useResponsive();

  const {
    data,
    file_progress,
    sendMessage,
    editMessage,
    loading,
    error,
    updateTask,
    task_close_confirmation,
  } = useTask();

  const [comments_modal, setCommentsModal] = useState(false);
  const [accept_modal, setAcceptModal] = useState(false);
  const [cancel_modal, setCancelModal] = useState(false);

  const required_action_buttons = () => {
    switch (data?.status) {
      case 1:
        return [
          // {
          //   label: t("Accept terms"),
          //   variant: "success",
          //   onclick: () => updateTask({ status: 2 }),
          // },
          {
            label: t("Cancel task"),
            icon: <TrashIcon />,
            variant: "error",
            onclick: () => setCancelModal(true),
          },
        ];
      case 4:
        return [
          {
            label: t("Accept and close task"),
            icon: <CheckIcon />,
            variant: "success",
            onclick: () => setAcceptModal(true),
          },
          {
            label: t("Request a correction"),
            icon: <PencilIcon />,
            onclick: () => setCommentsModal(true),
          },
        ];
      default:
        return null;
    }
  };

  const action_buttons = required_action_buttons();

  useEffect(() => {
    if (error) navigate("/tasks");
  }, [error, navigate]);

  if (error) return null;

  return (
    <DashboardContentLayout
      backMobile={() => navigate(`/tasks${location.search}`)}
      header={{
        label: data?.title,
        description: data?.website,
        actions: !max.sm && !loading && (
          <p>
            {t("Created at")}{" "}
            <strong>{moment(data?.created_at).format("LL")}</strong>
          </p>
        ),
      }}
      loading={loading}
      actions={action_buttons}
      showActionsMobile
    >
      {!!!task_close_confirmation ? (
        <>
          <TaskView
            data={data}
            website={{
              name: data?.website,
            }}
            loading={loading}
            file_progress={file_progress}
            updateTask={updateTask}
            sendMessage={sendMessage}
            editMessage={editMessage}
          />

          <ClientCommentsModal
            isOpen={comments_modal}
            onClose={() => setCommentsModal(false)}
          />
          <AcceptTaskModal
            title={data?.title}
            isOpen={accept_modal}
            onClose={() => setAcceptModal(false)}
          />
          <CancelTaskModal
            title={data?.title}
            isOpen={cancel_modal}
            onClose={() => setCancelModal(false)}
          />
        </>
      ) : (
        <PlaceholderPage
          title={t("The task has been finished!")}
          text={t(
            "We are glad we could help and would like to thank you for fruitful cooperation :)",
          )}
          button={{
            label: t("Manage your website"),
            href: "/websites",
          }}
        />
      )}
    </DashboardContentLayout>
  );
};

const TaskSingleWrapper = () => (
  <TaskProvider>
    <TaskSingle />
  </TaskProvider>
);

export default TaskSingleWrapper;
